import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom';
import { fetchProductDetailsThunk } from '../features/product/productDetails';
function ProductPage() {
   const {pId} = useParams();
   console.log("pId:", pId);
   const dispatch = useDispatch()
   useEffect(()=>{
    dispatch(fetchProductDetailsThunk(pId))
   }, [pId])
   const product = useSelector(state=>state.productDetails)
  console.log(product);
  
  return (
    <div>ProductPage</div>
  )
}

export default ProductPage